/**
 * Used to get the index that's contrained within an `Array.length`.
 *
 * This is very useful for implementing a "next" and "previous" feature.
 * If the incoming index if more then the length or less than 0 (zero),
 * the output index will be the "looped" index.
 *
 * @example
 *
 * ```jsx
 * const length = 10
 *
 * function getNextIndex() {
 *  const currentIndex = 9;
 *  return modulus(currentIndex + 1, length); // 0
 * }
 *
 * function getPrevIndex() {
 *  const currentIndex = 0;
 *  return modulus(currentIndex - 1, length); // 9
 * }
 * ```
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
 */
export function modulus(index: number, length: number): number {
  return ((index % length) + length) % length;
}
